import { type FC } from 'react'
import { LinkButton } from '../../../components/Button/LinkButton'
import { SchedulingStatusCard } from '../SchedulingStatusCard'

export interface SchedulingUnavailableStateProps {
  isAdmin: boolean
}

export const SchedulingUnavailableState: FC<SchedulingUnavailableStateProps> = ({ isAdmin }) => (
  <SchedulingStatusCard
    icon={<i className='bi bi-calendar zocks-text-gray-600' />}
    title="Scheduling isn't available for your account"
    subtitle={
      isAdmin
        ? "Scheduling needs a connected calendar. Google Calendar and Outlook Calendar aren't available for this account."
        : "Scheduling needs a connected calendar. Google Calendar and Outlook Calendar aren't available for this account. Ask your account owner if this can change."
    }
  >
    {isAdmin ? (
      <LinkButton variant='primary' to='/account/integration-settings/integrations'>
        Manage your integrations
      </LinkButton>
    ) : null}
  </SchedulingStatusCard>
)
